import { api } from "@/api";

export interface RiskExemptionParams {
  providerId: number;
  providerMatchId: number;
  exempt: boolean;
}

export interface RiskExemptionResult {
  matchId: string;
  exempt: boolean;
}

// Dealer-only: switch one match in/out of the viewer's risk caps
// ("Muafiyet"). Step-up protected on the server; the axios interceptor opens
// the step-up dialog on 403 STEP_UP_REQUIRED and retries.
export const setRiskExemption = async (
  params: RiskExemptionParams
): Promise<RiskExemptionResult> => {
  const res = await api.client.put(
    `/risk/exemptions/${params.providerId}/${params.providerMatchId}`,
    { exempt: params.exempt }
  );
  return res.data;
};
